<template>
  <div class="container" @click.stop="sliderFlag=!!0">
    <div v-if="handleShow" class="warning">
      <div class="warning-left">
        <img src="@/assets/views/map/warning1.png" class="warning-img" />
        <p class="warning-message">地图合并后</p>
        <p class="warning-message">才可以进行地图编辑</p>
      </div>
      <div class="warning-right">
        <!-- <div class="warning-right-border"></div> -->
      </div>
    </div>
    <div v-else class="list">
      <div class="menu">
        <div class="layer-btn" ref="layerBtn" @click="layerChange">图层</div>
        <!-- @click="pathChange" -->
        <div class="path-btn" ref="pathBtn">路径</div>
      </div>
      <div class="map">
        <div class="mapInfo">
          <div class="map-info">
            <img class="map-icon" src="@/assets/views/models/eye.png" alt />
            <span style="margin-left:10px">CAD图</span>
          </div>
          <div class="map-info">
            <span class="letter">不透明度</span>
            <span class="drop-down" style="margin-left:10px">
              <span class="opacity-percent" @click.stop="sliderFlag=!0">
                <span>{{ sliderValue }}%</span>

                <div class="triangle-box">
                  <span class="triangle"></span>
                </div>
                <div v-if="sliderFlag" class="slider-wrapper">
                  <el-slider
                    class="slider"
                    v-model="sliderValue"
                    @change="sliderHandle(sliderValue)"
                  ></el-slider>
                </div>
              </span>
            </span>
          </div>
        </div>
        <div class="original">
          <div class="original-center upload-button" @click="onClick($event)">
            <img
              v-show="!imagePreviewing"
              src="@/assets/views/models/add-file.png"
              class="icon-add"
            />
            <img v-show="imagePreviewing" :src="imagePreviewing" class="upload__image" />
          </div>
          <img
            v-show="imagePreviewing"
            src="@/assets/views/models/delete-cad.png"
            class="delete-cad"
            @click="deleteHandle"
          />
        </div>
        <div class="mapInfo">
          <div class="map-info">
            <img class="map-icon" src="@/assets/views/models/eye.png" alt />
            <span style="margin-left:10px">模型视图</span>
          </div>
        </div>
        <div class="original">
          <div class="original-center">
            <img v-show="modelPreviewing" :src="modelPreviewing" class="upload__image" />
            <div class="grow-less">
              <img
                v-show="modelPreviewing"
                src="@/assets/views/models/grow-cad.png"
                class="grow-cad"
                @click="growHandle"
              />
              <img
                v-show="modelPreviewing"
                src="@/assets/views/models/lesson-cad.png"
                class="lessen-cad"
                @click="lessenHandle"
              />
            </div>
          </div>

          <p ref="uploadButton" class="save-button-succee" @click="download">
            <img src="@/assets/views/models/download.png" alt />
            保存并下载底图
          </p>
        </div>
      </div>
    </div>
    <div class="canvas-content">
      <div v-show="false" id="buttondiv">
        <div id="buttonL">
          <input type="checkbox" :checked="is_checked" @click="(is_checked = !is_checked)" />显示图片
          <el-button @click="onClick($event)">打开图片</el-button>
        </div>
        <div id="buttonR">
          <el-button @click="getPoint($event)">保存坐标</el-button>
        </div>
      </div>
      <div v-show="is_checked" id="cadimagediv">
        <img v-if="imagePreviewing" ref="uploadImage" :src="imagePreviewing" class="upload__image" />
      </div>
      <div id="cadimagedivBG" />
      <div id="drawboard">
        <canvas id="canvas" />
      </div>
      <div id="canvas3d" class="canvas3d" />
    </div>

    <input
      v-show="!!0"
      ref="uploader"
      type="file"
      class="upload__input"
      :accept="accept"
      @change="previewImage"
    />
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import {
  Scene,
  Color,
  WebGLRenderer,
  AxisHelper,
  SpotLight,
  OrthographicCamera,
  CubeGeometry,
  Mesh,
  MeshBasicMaterial,
  Vector3
} from "three";

import { OrbitControls } from "../../../controls/OrbitControls";
import { GLTFLoader } from "../../../loaders/GLTFLoader";
// require('three/examples/jsm/loaders/GLTFLoader')
export default {
  name: "deleteMap",
  data() {
    return {
      sliderValue: 80,
      sliderFlag: !!0, //  不透明度显示
      imagePreviewing: null,
      modelPreviewing: null,
      handleShow: !!0,
      CANVAS_WIDTH: 0, // 场景宽高
      CANVAS_HEIGHT: 0,
      context: {}, // 2d context
      scene: {}, // 3d 场景
      loading: true,
      sceneData: [], // 场景数据
      pointUVList: [], // 映射点数据
      is_checked: true,
      cadSrc: "",
      cadWidth: "",
      cadHeight: "",
      shotImageUrl: "",
      httpAxios: axios.create({}),
      cadImageUrl: "",
      centerX: "",
      centerY: "",
      storeName: "",
      scale: "",
      handleShow: !!0,
      baseMap: "",
      center_x: 0,
      center_y: 0,
      theta: 0
    };
  },
  props: {
    text: { type: String, default: "上传文件" },
    sub: { type: String, default: "" },
    accept: { type: String, default: "image/*" },
    imageUrl: { type: String, default: null },
    width: { type: String, default: "100px" },
    height: { type: String, default: "100px" },
    size: { type: String, default: "normal" } /* eslint-disable */,
    filesize: 0
  },
  created() {},
  mounted() {
    this.canvas3d = document.querySelector("#canvas3d");

    const content = document.querySelector(".canvas-content");
    const width = content.clientWidth;
    const height = content.clientHeight;
    this.canvas3d.style.width =
      width > height ? `${height - 20}px` : `${width - 20}px`;
    this.canvas3d.style.height = this.canvas3d.style.width;
    // console.log(width, height);
    const drawboard = document.querySelector("#drawboard");
    drawboard.style.width = this.canvas3d.style.width;
    drawboard.style.height = this.canvas3d.style.width;
    // drawboard.style.left = "50% + 300px";
    // drawboard.style.bottom = "40px";
    const cadimagediv = document.querySelector("#cadimagediv");
    cadimagediv.style.width = this.canvas3d.style.width;
    cadimagediv.style.height = this.canvas3d.style.width;
    // drawboard.style.left = "50% + 300px";
    // cadimagediv.style.bottom = "40px";

    this.CANVAS_WIDTH = this.canvas3d.clientWidth;
    this.CANVAS_HEIGHT = this.canvas3d.clientHeight;
    // const canvas = document.querySelector("#canvas");
    if (this.$store.state.mergeFlag === "false") {
      // console.log('ok')
      this.handleShow = true;
      return;
    }

    this.context = canvas.getContext("2d");
    this.onInitialized();
    this.getStoreInfo();
  },
  methods: {
    onInitialized() {
      //  加载数据
      // this.loadSceneData();
      //  初始化3D场景
      // this.initMesh();
    },
    async getStoreInfo() {
      try {
        const { data } = await this.$http.post(
          "/admin/get-store-info?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so",
          { store_id: this.$route.query.store_id }
        );
        // console.log(data);
        if (data.error_no === 200) {
          this.storeName = data.data.store_name;
        }
        // console.log(data.data.store_name);
        // console.log(this.storeName);
      } catch (error) {
        this.$log(error.error_msg);
      }

      try {
        // this.$route.params.mapId
        const { data } = await this.$http.post(
          "/navigation/init-navigation-map",
          {
            map_id: this.$route.params.mapId
          }
        );
        // console.log(data);
        if (data.error_no === 200) {
          this.theta = data.data.theta;
          this.center_x = data.data.center_x;
          this.center_y = data.data.center_y;
          this.initial_x = data.data.initial_x;
          this.initial_y = data.data.initial_y;
          console.log(
            this.theta,
            this.center_x,
            this.center_y,
            this.initial_x,
            this.initial_y
          );

          this.convertImgToBase64(data.data.map_cad, base64Img => {
            // console.log(base64Img);
            this.$store.commit("getCADUrl", base64Img);
            this.$store.commit("getAlign", data.data.is_aligned);
            this.imagePreviewing = this.$store.state.CADUrl;
          });

          this.loadSceneData();
          this.initMesh();
          
          
          // this.mcontrols.target.y =1.89; 
          // this.mcontrols.panLeft2()
          // this.mcontrols.panUp2()
          // this.mcontrols.update();
          // this.renderThisFrame = true;
          
          // console.log(this.camera.rotation)

          // this.storeName = data.data.store_name;
        }
      } catch (error) {
        this.$log(error.error_msg);
      }
    },
    convertImgToBase64(url, callback, outputFormat) {
      var canvas = document.createElement("CANVAS"),
        ctx = canvas.getContext("2d"),
        img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = function() {
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL(outputFormat || "image/png");
        callback.call(this, dataURL);
        canvas = null;
      };
      img.src = url;
    },
    getCurrentShot(width, height, flag) {
      //  获取3D 当前截图
      // const shotimage = new Image(this.CANVAS_WIDTH,this.CANVAS_HEIGHT);
      const shotimage = new Image(width, height);
      try {
        this.renderer.render(this.scene, this.camera);
        const imgData = this.renderer.domElement.toDataURL("image/jpeg");
        shotimage.src = imgData;
        this.shotImageUrl = imgData;
        // console.log(imgData);
      } catch (e) {
        console.error(e);
      }

      if (flag) this.downloadIamge3d(this.shotImageUrl);
      return shotimage;
    },
    downloadIamge3d(imgsrc, name) {
      //下载图片地址和图片名
      // let image = new Image(1000, 1000);
      // // 解决跨域 Canvas 污染问题
      // image.setAttribute("crossOrigin", "anonymous");
      // image.onload = function() {
      //   let canvas = document.createElement("canvas");
      //   canvas.width = image.width;
      //   canvas.height = image.height;
      //   let context = canvas.getContext("2d");
      //   context.drawImage(
      //     image,
      //     0,
      //     0,
      //     this.canvasWidth,
      //     this.canvasHeight,
      //     0,
      //     0,
      //     this.canvasWidth,
      //     this.canvasHeight
      //   );
      //   let url = canvas.toDataURL("image/jpeg"); //得到图片的base64编码数据
      let url = this.shotImageUrl;
      let a = document.createElement("a"); // 生成一个a元素
      let event = new MouseEvent("click"); // 创建一个单击事件
      a.download = name || "photo"; // 设置图片名称
      a.href = url; // 将生成的URL设置为a.href属性
      a.dispatchEvent(event); // 触发a的单击事件
      // };
      // image.src = imgsrc;
    },
    downloadIamge(imgsrc, name) {
      //下载图片地址和图片名
      // let image = new Image(1000, 1000);
      // // 解决跨域 Canvas 污染问题
      // image.setAttribute("crossOrigin", "anonymous");
      // image.onload = function() {
      //   let canvas = document.createElement("canvas");
      //   canvas.width = image.width;
      //   canvas.height = image.height;
      //   let context = canvas.getContext("2d");
      //   context.drawImage(image, 0, 0, image.width, image.height);
      // let url = canvas.toDataURL("image/jpeg"); //得到图片的base64编码数据
      let url = imgsrc;
      let a = document.createElement("a"); // 生成一个a元素
      let event = new MouseEvent("click"); // 创建一个单击事件
      a.download = name || "photo"; // 设置图片名称
      a.href = url; // 将生成的URL设置为a.href属性
      a.dispatchEvent(event); // 触发a的单击事件
      // };
      // image.src = imgsrc;
    },
    async loadSceneData() {
      // 加载数据
      this.loading = true;
      const {
        data: { data: sceneData }
      } = await this.$http.post(
        "/v1/list-panoramas?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so",
        { store_id: this.$route.query.store_id }
      );
      //  console.log(sceneData);
      this.scenePoint = sceneData.panorama_list.map(pano => {
        const p = { coordinate: {} };
        p.coordinate.positionX = pano.coordinate.position_x;
        p.coordinate.positionY = pano.coordinate.position_y;
        p.coordinate.positionZ = pano.coordinate.position_z;
        p.coordinate.directionX = pano.coordinate.direction_x;
        p.coordinate.directionY = pano.coordinate.direction_y;
        p.coordinate.directionZ = pano.coordinate.direction_z;
        p.coordinate.directionW = pano.coordinate.direction_w;
        p.coordinate.panoramaId = pano.coordinate.panorama_id;
        p.coordinate.id = pano.coordinate.id;
        p.panoramaImages = pano.panorama_images;
        p.panoramaImagesLow = pano.panorama_images_low;
        p.sequenceId = pano.seq_id;
        p.visiblePanoramaSequenceIds = pano.visible_panorama_seq_ids;
        p.visible = pano.visible;
        p.id = pano.id;
        return p;
      });
      //  console.log(this.sceneData);
      this.loadModel(sceneData.modelPath);
    },

    renderScene() {
      //  渲染3D场景
      if (this.renderThisFrame) {
        this.renderer.render(this.scene, this.camera);

        // if (this.camera) console.log(this.camera.rotation,this.camera.position);
        // if(this.mcontrols) console.log(this.mcontrols.object.rotation,this.mcontrols.object.position);
      }
      this.renderThisFrame = false;
      requestAnimationFrame(this.renderScene);
    },
    backGroundColorChange(a, b) {
      a.backgroundColor = "#393939";
      b.backgroundColor = "#282828";
    },
    layerChange() {
      this.backGroundColorChange(
        this.$refs.layerBtn.style,
        this.$refs.pathBtn.style
      );
    },
    pathChange() {
      this.backGroundColorChange(
        this.$refs.pathBtn.style,
        this.$refs.layerBtn.style
      );
    },
    sliderHandle(value) {
      this.$refs.uploadImage.style.opacity = value / 100;
    },
    onClick() {
      this.$refs.uploader.click();
    },
    previewImage() {
      //  加载2D图

      const fileReader = new FileReader();
      fileReader.addEventListener(
        "load",
        () => {
          this.imagePreviewing = fileReader.result;

          this.$store.commit("getCADUrl", fileReader.result);
          const thethis = this; /* eslint-disable */
          const image = new Image();
          image.src = fileReader.result; // eslint-disable-next-line
          this.cadSrc = fileReader.result;
          image.onload = function() {
            thethis.$emit("imagescale", this.width / this.height);
            thethis.cadHeight = this.height;
            thethis.cadWidth = this.width;
          }; /* eslint-disable */
        },
        false
      );
      const file = this.$refs.uploader.files[0]; /* eslint-disable */
      if (file) {
        fileReader.readAsDataURL(file);
        this.$emit("filesize", file.size);
      }
      //else this.imagePreviewing = null;
    },
    async deleteHandle() {
      // console.log(this.$refs.uploader.value);
      this.$refs.uploader.value = "";
      this.imagePreviewing = null;
      try {
        const { data } = await this.$http.post("/navigation/delete-cad-map", {
          map_id: Number(this.$route.params.mapId)
        });
        // console.log(data);

        if (data.retcode === 0) {
          // console.log('delete');

          this.$store.commit("getAlign", !!0);
          // this.getCurrentShot(this.CANVAS_WIDTH, this.CANVAS_WIDTH, true);
          // this.cmdCanvas();
        }
      } catch (error) {
        console.log("align err");
        this.$log(error.error_msg);
      }
    },
    initMesh() {
      // 初始化场景
      this.scene = new Scene(); // 场景
      this.scene.background = new Color(196, 196, 196);
      this.camera = new OrthographicCamera(-20, 20, 20, -20, 0.1, 1000);
      // this.camera.position.x = x;
      this.camera.position.y = 100;

      this.camera.lookAt(this.scene.position);
      this.renderer = new WebGLRenderer({
        antialias: true,
        preserveDrawingBuffer: true
      }); // 渲染器
      this.renderer.setSize(this.CANVAS_WIDTH, this.CANVAS_HEIGHT);
      const axes = new AxisHelper(20); // 坐标轴
      const spotLight = new SpotLight(0xffffff);
      spotLight.position.set(-40, 200, -10);
      spotLight.castShadow = true;
      this.scene.add(axes); // 场景添加坐标轴
      this.scene.add(spotLight);
      this.canvas3d.append(this.renderer.domElement);
      this.renderThisFrame = true;
      this.renderScene();
      this.mcontrols = new OrbitControls(this.camera, this.renderer.domElement);
      this.mcontrols.enablerotateUp = false;
      // this.mcontrols.panLeft2(3);
      // this.mcontrols.rotateLeft(30);
      //  事件
      this.mcontrols.addEventListener("_render", () => {
        this.renderThisFrame = true;
      });
    },
    loadModel(modelPath) {
      
      //  加载模型
      const gltfLoader = new GLTFLoader();
      gltfLoader.load(modelPath, gltf => {
        const object = gltf.scene;
        object.rotateX(-Math.PI / 2);
        object.updateWorldMatrix();
        this.model = object;
        this.scene.add(object);
        this.draw3DPotint();
        this.renderThisFrame = true;
        this.loading = false;
        object.children[0].geometry.computeBoundingBox();
        //  object.children[0].geometry.center()
        // console.log( object.children[0].geometry.boundingBox.max.x);
        // console.log(object.children[0].geometry.boundingBox.max.y);
        // console.log(object.children[0].geometry.boundingBox.max.z);
        this.mcontrols.panLeft2(
          -(
            object.children[0].geometry.boundingBox.max.x +
            object.children[0].geometry.boundingBox.min.x
          ) / 2
        );
        this.mcontrols.panUp2(
          (object.children[0].geometry.boundingBox.max.y +
            object.children[0].geometry.boundingBox.min.y) /
            2
        );
        this.mcontrols.update();
        //截图
        this.modelPreviewing = this.getCurrentShot(150, 150, false).src;
      });
    },
    draw3DPotint() {
      //  根据数据绘制3D全景点位
      this.scenePoint.forEach(element => {
        const cube = new Mesh(
          new CubeGeometry(1, 1, 1, 1, 1, 1),
          new MeshBasicMaterial({ color: 0xff0000, wireframe: true })
        );
        let orgposition = new Vector3(
          element.coordinate.positionX,
          element.coordinate.positionY,
          element.coordinate.positionZ
        );
        orgposition = orgposition
          .clone()
          .applyAxisAngle(new Vector3(1, 0, 0), -Math.PI / 2);
        cube.position.x = orgposition.x;
        cube.position.y = orgposition.y;
        cube.position.z = orgposition.z;
        this.scene.add(cube);
        element.cube = cube;
      });
    },
    lessenHandle() {
      this.mcontrols.setDolly(0);
    },
    growHandle() {
      this.mcontrols.setDolly(1);
    },
    download() {
      // console.log(this.imagePreviewing);

      Promise.all([this.saveCADImage(), this.saveModelImage()])
        .then(val => {
          const arr = val.map(o => o.retcode);
          // console.log(arr, val);
          if (arr[0] === arr[1]) {
            this.$message.basic({
              message: "对齐参数已保存"
            });
            const arr = val
              .map(o => o.data)
              .map(i =>
                i.map(j => {
                  return j.url;
                })
              );
            const floorModel = arr[1][0];
            const floorCad = arr[0][0];
            this.saveAlignMent(floorModel, floorCad);
          } else {
            this.$log(111);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    async saveAlignMent(floorModel, floorCad) {
     
      this.baseMap = floorModel;
      this.getPoint();
      const zero = new Vector3(0, 0, 0).project(this.camera);
      zero.x =
        ((this.CANVAS_WIDTH * zero.x) / 2 + this.CANVAS_WIDTH / 2) /
        this.CANVAS_WIDTH;
      zero.y =
        ((-this.CANVAS_WIDTH * zero.y) / 2 + this.CANVAS_WIDTH / 2) /
        this.CANVAS_WIDTH;
      const params = {
        map_id: Number(this.$route.params.mapId),
        map_model: floorModel,
        map_cad: floorCad,
        align_width: 1000,
        align_height: 1000,
        center_x: zero.x,
        center_y: zero.y,
        scale: this.scale,
        theta: this.mcontrols.getRotate()
      };
      //  console.log(this.mcontrols.target.y,this.mcontrols.object.position.x - this.initX,this.mcontrols.object.position.z - this.initY);
      console.log(params.theta,params.center_x,params.center_y);
      

      try {
        const { data } = await this.$http.post("/navigation/align", params);

        if (data.retcode === 0) {
          this.getCurrentShot(this.CANVAS_WIDTH, this.CANVAS_WIDTH, true);

          this.cmdCanvas();
        }
      } catch (error) {
        console.log("align err");
        this.$log(error.error_msg);
      }
    },
    getPoint() {
      //   3D - 2D 坐标映射并存储到数组中
      this.scenePoint.forEach(element => {
        const vector2D = element.cube.position.clone().project(this.camera);
        vector2D.x =
          (this.CANVAS_WIDTH * vector2D.x) / 2 + this.CANVAS_WIDTH / 2;
        vector2D.y =
          (-this.CANVAS_WIDTH * vector2D.y) / 2 + this.CANVAS_WIDTH / 2;
        const point2D = {
          id: element.id,
          position: vector2D
        };
        const arcPosX = point2D.position.x; // 20,20 是右面布局的起始坐标
        const arcPosY =
          point2D.position.y -
          document.getElementById("drawboard").offsetTop -
          20 +
          40;
        this.draw2DPoint(arcPosX, arcPosY, 1);
        this.renderThisFrame = true;
        this.pointUVList.push({
          x2d: arcPosX / this.CANVAS_WIDTH,
          y2d: arcPosY / this.CANVAS_WIDTH,
          p3x: element.cube.position.x,
          p3y: element.cube.position.y,
          p3z: element.cube.position.z
        });
      });

      const zero = new Vector3(0, 0, 0).project(this.camera);
      zero.x =
        ((this.CANVAS_WIDTH * zero.x) / 2 + this.CANVAS_WIDTH / 2) /
        this.CANVAS_WIDTH;
      zero.y =
        ((-this.CANVAS_WIDTH * zero.y) / 2 + this.CANVAS_WIDTH / 2) /
        this.CANVAS_WIDTH;

      const d2x = Math.pow(
        this.pointUVList[0].x2d * this.CANVAS_WIDTH -
          zero.x * this.CANVAS_WIDTH,
        2
      );
      const d2y = Math.pow(
        this.pointUVList[0].y2d * this.CANVAS_HEIGHT -
          zero.y * this.CANVAS_HEIGHT,
        2
      );
      const d2d = Math.sqrt(d2x + d2y);
      const d3x = Math.pow(this.pointUVList[0].p3x - 0, 2);
      const d3y = Math.pow(this.pointUVList[0].p3z - 0, 2);
      const d3d = Math.sqrt(d3x + d3y);

      this.scale = d2d / d3d;

      console.log("this.scale:", this.scale);
    },
    async savePointUV() {
      //  console.log('save image and point UV!');
      try {
        const { data } = await this.$http.post("/admin/modify-store-uv-list", {
          store_id: this.$route.query.store_id,
          uv_list: this.pointUVList
        });
        //  console.log(data);
        if (data.error_no === 200) {
          this.$message.basic({
            message: "添加UV成功"
          });
          this.closeDialog();
        } else {
          this.$log(data.error_msg);
        }
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    draw2DPoint(posX, posY, radius) {
      // 绘制对齐后2D坐标点，方便查看
      this.context.beginPath();
      //  this.context.fillText(id, posX, posY);
      this.context.arc(posX, posY, radius, 0, 2 * Math.PI, true);
      this.context.closePath();
      this.context.stroke();
      this.context.fill();
    },
    cmdCanvas() {
      this.toBase64();
      this.downloadIamge(this.cadImageUrl);
    },
    toBase64() {
      let drawImageWidth,
        drawImageHeight,
        spaceWidth,
        spaceHeight,
        flag = true,
        flagOne = true;
      const canvas = document.createElement("canvas");
      canvas.width = this.CANVAS_WIDTH;
      canvas.height = this.CANVAS_HEIGHT;
      // if (this.cadWidth > 1000) {
      //   drawImageWidth = 1000;
      //   drawImageHeight = this.cadHeight * 1000 / this.cadWidth;
      //   spaceWidth = 0;
      //   spaceHeight = (drawImageHeight -1000 ) / 2;
      //   flag = false;
      // }
      // if (flag && this.cadHeight > 1000) {
      //   drawImageWidth = this.cadWidth * 1000 / this.cadHeight;
      //   drawImageHeight = 1000;
      //   spaceWidth = (1000 - drawImageWidth) / 2;
      //   spaceHeight = 0;
      //   flagOne = false;
      // }
      // if(flagOne && this.cadWidth < 1000) {
      //   drawImageWidth = this.cadWidth;
      //   spaceWidth = (1000 - this.cadWidth) / 2;
      // }
      // if(this.cadHeight < 1000) {
      //   drawImageHeight = this.cadHeight;
      //   spaceHeight = (1000 - drawImageHeight) / 2;
      // }
      //--------------------------changed-by-jshi--------
      const whscale = this.cadWidth / this.cadHeight;

      // console.log(document.querySelector('#canvas3d'));

      const ctx = canvas.getContext("2d");
      const img = document.getElementsByClassName("upload__image")[0];

      if (whscale === 1) {
        ctx.drawImage(img, 0, 0, this.CANVAS_WIDTH, this.CANVAS_HEIGHT);
      } else if (whscale > 1) {
        // console.log((this.cadWidth - this.cadHeight) / 2);

        ctx.drawImage(
          img,
          0,
          (this.CANVAS_WIDTH - this.CANVAS_WIDTH / whscale) / 2,
          this.CANVAS_WIDTH,
          this.CANVAS_HEIGHT / whscale
        );
      } else {
        ctx.drawImage(
          img,
          (this.CANVAS_WIDTH - this.CANVAS_WIDTH / whscale) / 2,
          0,
          this.CANVAS_WIDTH * whscale,
          this.CANVAS_HEIGHT
        );
      }
      this.cadImageUrl = canvas.toDataURL("image/jpeg");
      // console.log(img,this.cadImageUrl);
      // console.log(this.cadImageUrl);
      // console.log(this.cadImageUrl);
      // console.log(this.renderer.domElement.toDataURL("image/jpeg"));

      // if (this.cadHeight > this.CANVAS_HEIGHT) {
      //   drawImageHeight = this.CANVAS_HEIGHT;
      //   drawImageWidth = whscale * this.CANVAS_WIDTH;
      //   if (drawImageWidth > this.CANVAS_WIDTH) {
      //     drawImageWidth = this.CANVAS_WIDTH;
      //     drawImageHeight = drawImageWidth / whscale;
      //     spaceWidth = 0;
      //     spaceHeight = (this.CANVAS_HEIGHT - drawImageHeight) / 2;
      //   } else {
      //     spaceWidth = (this.CANVAS_WIDTH - drawImageWidth) / 2;
      //     spaceHeight = 0;
      //   }
      // }
      // if (this.cadWidth > this.CANVAS_WIDTH) {
      //   drawImageWidth = this.CANVAS_WIDTH;
      //   drawImageHeight = drawImageWidth / whscale;
      //   spaceWidth = 0;
      //   spaceHeight = (this.CANVAS_HEIGHT - drawImageHeight) / 2;

      //   if (drawImageHeight > this.CANVAS_HEIGHT) {
      //     drawImageHeight = this.CANVAS_HEIGHT;
      //     drawImageWidth = whscale * this.CANVAS_WIDTH;

      //     spaceWidth = (this.CANVAS_WIDTH - drawImageWidth) / 2;
      //     spaceHeight = 0;
      //   }
      // }
      // const ctx = canvas.getContext("2d");
      // const img = document.getElementsByClassName("upload__image")[0];
      // //  console.log('cmdCanvas:',this.cadWidth,this.cadHeight,spaceWidth,spaceHeight,drawImageWidth, drawImageHeight);
      // ctx.drawImage(
      //   img,
      //   spaceWidth,
      //   spaceHeight,
      //   drawImageWidth,
      //   drawImageHeight
      // );
      // this.cadImageUrl = canvas.toDataURL("image/jpeg");
      // console.log(this.cadImageUrl);
    },
    saveCADImage() {
      // console.log(this.imagePreviewing);

      if (!this.imagePreviewing) {
        this.$confirm({
          title: "警告",
          message: "请先上传CAD图片?"
        });
        return;
      }
      const randomNumber = this.randomWord(false, 32);
      this.toBase64();
      // console.log(this.cadImageUrl);

      return new Promise((resolve, reject) => {
        this.$http
          .post(
            "/upload/map/" + randomNumber + ".jpg",
            this.cadImageUrl.substr(
              this.cadImageUrl.indexOf(",") + 1,
              this.cadImageUrl.length
            ),
            { headers: { "Content-Type": "text/plain" } }
          )
          .then(response => {
            this.$store.commit("getAlign", !0);
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    saveModelImage() {
      const randomNumber = this.randomWord(false, 32);
      // console.log(this.shotImageUrl);

      return new Promise((resolve, reject) => {
        this.$http
          .post(
            "/upload/map/" + randomNumber + ".jpg",
            this.shotImageUrl.substr(
              this.shotImageUrl.indexOf(",") + 1,
              this.shotImageUrl.length
            ),
            { headers: { "Content-Type": "text/plain" } }
          )
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },

    randomWord(randomFlag, min, max) {
      let str = "",
        range = min,
        arr = [
          "0",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "a",
          "b",
          "c",
          "d",
          "e",
          "f",
          "g",
          "h",
          "i",
          "j",
          "k",
          "l",
          "m",
          "n",
          "o",
          "p",
          "q",
          "r",
          "s",
          "t",
          "u",
          "v",
          "w",
          "x",
          "y",
          "z"
        ];
      // 随机产生
      if (randomFlag) {
        range = Math.round(Math.random() * (max - min)) + min;
      }
      for (let i = 0; i < range; i++) {
        let pos = Math.round(Math.random() * (arr.length - 1));
        str += arr[pos];
      }
      return str;
    }
  }
};
</script>


<style lang='scss' scoped>
// @import url("../stylus/cad.scss");
@mixin center() {
  display: flex;
  justify-content: center;
  align-items: center;
}

@mixin left() {
  display: flex;
  justify-content: left;
  align-items: center;
}

@mixin verticalCenter() {
  display: flex;
  align-items: center;
}

@mixin range() {
  width: 100%;
  height: 100%;
}

@mixin borderTop() {
  border-top: 1px solid #181818;
}

@mixin border() {
  border: 1px solid #181818;
}

@mixin font() {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #adadad;
  letter-spacing: 0.64px;
}

.upload__image {
  width: calc(100% - 4px);
  height: calc(100% - 4px);
  padding: 2px;
  object-fit: contain;
  opacity: 0.8;
}

.map-icon {
  width: 19.5px;
  height: 19.5px;
}

.container {
  width: 100%;
  height: 100%;
  background: #424242;
  border: 0 solid #181818;
  display: flex;
  .warning {
    width: 100%;
    height: 100%;
    @include center;
    .warning-left {
      @include center;
      width: 300px;
      height: 100%;
      flex-direction: column;
      .warning-message {
        font-size: 20px;
        color: #adadad;
        text-align: center;
        margin: 0;
      }
      .warning-img {
        width: 28px;
        height: 28px;
        margin-bottom: 22px;
      }
    }
    .warning-right {
      width: calc(100% - 300px);
      height: 100%;
      background: #424242;
      @include center;
      .warning-right-border {
        width: 90%;
        height: 90%;
        border: 2px dashed #979797;
        border-radius: 4px;
      }
    }
  }

  .list {
    @include center;
    width: 300px;
    flex-wrap: wrap;

    .menu {
      height: 50px;
      width: 100%;
      cursor: pointer;

      .layer-btn {
        width: calc(50% - 2px);
        height: 50px;
        @include border;
        @include center;
        @include font;
        background: #393939;
      }

      .path-btn {
        width: calc(50% - 2px);
        height: 50px;
        @include border;
        @include center;
        @include font;
        background: #282828;
        cursor: wait;
      }
    }

    .map {
      height: calc(100% - 51px);
      width: calc(100% - 2px);
      background: #393939;
      // @include borderTop;

      .mapInfo {
        @include verticalCenter;
        @include font;
        @include borderTop;
        height: 29px;

        .map-info {
          width: 50%;
          @include left;

          .letter {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #adadad;
            letter-spacing: 0.56px;
          }

          .drop-down {
            background: #282828;
            border: 1px solid #adadad;
            border-radius: 4px;
            width: 60px;
            height: 18px;
            @include center;

            .opacity-percent {
              font-family: PingFangSC-Regular;
              font-size: 12px;
              color: #cccccc;
              text-align: center;
              @include center;
              overflow: auto;
              .triangle-box {
                margin-left: 12px;
                width: 7.9px;
                height: 4.6px;

                .triangle {
                  cursor: pointer;
                  float: left;
                  width: 0;
                  height: 0;
                  top: 7px;
                  right: 7px;
                  border-width: 4px;
                  border-style: solid;
                  border-color: #adadad transparent transparent transparent;
                }
              }
              .slider-wrapper {
                // @include center;
                width: 120px;
                height: 25px;
                background: #424242;
                box-shadow: 0 1px 4px 2px rgba(0, 0, 0, 0.2);
                border-radius: 4px;
                position: absolute;
                top: 140px;
                z-index: 1000;
                margin-left: -18px;
                @include center;
                .slider {
                  width: 90%;
                  @include center;
                  /deep/.el-tooltip {
                    background: url("../../../assets/views/models/slider.png")
                      no-repeat;
                    width: 12px;
                    height: 12px;
                    border: none;
                  }
                  /deep/.el-slider__runway {
                    height: 2px;
                    background-color: rgb(140, 140, 140);
                  }
                  /deep/.el-slider__bar {
                    height: 2px;
                    background-color: rgb(140, 140, 140);
                  }
                  /deep/.el-slider__button-wrapper {
                    top: -18px;
                  }
                }
              }
            }
          }
        }
      }
      .original {
        @include borderTop;
        // @include center;
        // flex-wrap: wrap;

        .save-button-succee {
          @include center;
          width: 200px;
          height: 40px;
          line-height: 40px;
          border-radius: 4px;
          font-size: 16px;
          text-align: center;
          margin-left: 48px;
          margin-top: 40px;
          margin-bottom: 20px;
          color: #08ce82;
          border: 1px solid #08ce82;
          cursor: pointer;
        }
        .original-center {
          width: 148px;
          height: 148px;
          margin: 24px 75px;
          border: 2px dashed #adadad;
        }
        .grow-less {
          width: 54px;
          float: right;
          position: relative;
          top: -24px;
          right: -63px;
          .lessen-cad {
            width: 24px;
            height: 24px;
            float: right;
          }

          .grow-cad {
            width: 24px;
            height: 24px;
            float: left;
          }
        }

        .upload-button {
          @include center;
          border-radius: 6px;
          cursor: pointer;

          .icon-add {
            width: 24.5px;
            height: 24.5px;
          }
        }
        .delete-cad {
          width: 24px;
          height: 24px;
          float: right;
          position: relative;
          top: -50px;
          right: 30px;
        }
      }
    }
  }
  .canvas-content {
    width: calc(100% - 300px);
    height: 100%;
    @include center;
    #cadimagediv {
      pointer-events: none;
      position: absolute;
      z-index: 1;
    }
    #drawboard {
      pointer-events: none;
      position: absolute;
      z-index: 1;
      #canvas {
        width: 100%;
        height: 100%;
      }
    }

    // .canvas3d {
    //   width: 100%;
    //   height: 100%;
    // }
  }
}
</style>
